var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDiagLeftUp = function SvgArrowDiagLeftUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "arrow-diag-left-up_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m6.258 35.6 3.996-.031.03-22.448 44.042 44.041 2.836-2.836-44.041-44.042 22.448-.03.032-3.996H6.258z",
    clipRule: "evenodd"
  })));
};
export { SvgArrowDiagLeftUp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYuMjU4MDYgMzUuNjAwN0wxMC4yNTM2IDM1LjU2ODZMMTAuMjg0NCAxMy4xMjA5TDU0LjMyNTkgNTcuMTYyNEw1Ny4xNjI0IDU0LjMyNTlMMTMuMTIwOSAxMC4yODQ0TDM1LjU2ODYgMTAuMjUzNkwzNS42MDA3IDYuMjU4MDZINi4yNTgwNlYzNS42MDA3WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";